export default __webpack_public_path__ + "static/media/rectangles-no-6.b547a8d8.ogg";